<template>
  <div class="wrapper">
    <div @click="updateInput" class="checkbox" :class="getClass">
    </div>
  </div>

</template>

<script>
import AttributeReport from '../features/reports/attribute/AttributeReport'

export const STATE = {
  NOT_SELECTED: false,
  PLUS: 'plus',
  MINUS: 'minus'
}
/**
 * Checkbox like component that has three states: not-selected, minus and plus. Used in {@link AttributeReport} component
 */
export default {
  name: 'BaseThreePositionCheckBox',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      default: STATE.NOT_SELECTED
    },
    disabled: {
      default: false
    }
  },
  computed: {
    isDisabled () {
      return this.disabled && !this.modelValue
    },
    getClass () {
      if (this.isDisabled) {
        return {
          'checkbox_disabled': true
        }
      }
      switch (this.modelValue) {
        case STATE.MINUS:
          return {
            'checkbox__minus': true
          }
        case STATE.PLUS:
          return {
            'checkbox__plus': true
          }
        default:
          return {
            'checkbox__not_selected': true
          }
      }
    }
  },
  methods: {
    updateInput () {
      if (this.disabled && !this.modelValue) {
        return
      }
      const states = [ STATE.NOT_SELECTED, STATE.PLUS, STATE.MINUS ]
      const nextIndex = states.indexOf(this.modelValue) >= 2 ? 0 : states.indexOf(this.modelValue) + 1
      this.modelValue = states[ nextIndex ]
      this.$emit('change', this.modelValue)
    }
  }
}
</script>

<style scoped lang="scss">
  .wrapper {
    display: flex;
    flex: 0 0 20px;
    align-items: center;
    justify-content: center;
  }
  .checkbox {
    width: 20px;
    height: 20px;
    box-sizing: border-box;

    &__not_selected {
      color: $rfx-light-steel;
      border: 2px solid currentColor;
      border-radius: 4px;
      background-color: $rfx-almost-white-lighter;
    }

    &__plus {
      position: relative;
      width: 20px;
      height: 20px;
      background-color: $rfx-bright-blue;
      cursor: pointer;
      border-radius: 4px;
      border-width: 0;

      &:before, &:after {
        position: absolute;
        left: 9px;
        top: 5px;
        content: '';
        height: 10px;
        width: 2px;
        background-color: #fff;
      }

      &:before {
        transform: rotate(0deg);
      }

      &:after {
        transform: rotate(-90deg);
      }
    }

    &__minus {
      position: relative;
      width: 20px;
      height: 20px;
      background-color: $rfx-bright-blue;
      cursor: pointer;
      border-radius: 4px;
      border-width: 0;

      &:after {
        position: absolute;
        left: 9px;
        top: 5px;
        content: '';
        height: 10px;
        width: 2px;
        background-color: #fff;
      }

      &:after {
        transform: rotate(-90deg);
      }
    }

    &_disabled {
      background-color: $rfx-light-grey !important;
      border-radius: 4px;
      border-width: 0;
    }

  }
</style>
